export function TextPreviewLoading() {
  return (
    <div
      aria-busy="true"
      aria-label="正在加载文本详情"
      className="mx-auto w-full max-w-4xl animate-pulse px-5 pt-8 sm:px-10 lg:px-16"
    >
      <div className="h-9 w-48 rounded-lg bg-muted" />
      <div className="mt-4 flex items-center gap-3">
        <div className="h-5 w-24 rounded-md bg-muted" />
        <div className="size-1 rounded-full bg-muted" />
        <div className="h-7 w-20 rounded-md bg-muted" />
        <div className="size-1 rounded-full bg-muted" />
        <div className="h-7 w-24 rounded-md bg-muted" />
      </div>

      <div className="mt-12 space-y-5">
        <div className="h-5 w-full rounded-md bg-muted" />
        <div className="h-5 w-[92%] rounded-md bg-muted" />
        <div className="h-5 w-[78%] rounded-md bg-muted" />
        <div className="pt-5">
          <div className="h-7 w-44 rounded-md bg-muted" />
        </div>
        <div className="h-5 w-full rounded-md bg-muted" />
        <div className="h-5 w-[86%] rounded-md bg-muted" />
        <div className="h-5 w-[94%] rounded-md bg-muted" />
        <div className="h-5 w-[68%] rounded-md bg-muted" />
      </div>
    </div>
  );
}
